import { Component, input } from '@angular/core';
import type { FormArray, FormControl } from '@angular/forms';

import type { InterviewResultAnswerOption, RatingLevelType } from '@core/interview-results-types';
import { BoxComponent, DividerComponent } from '@core/user-interface-legacy';

import { EvaluationRatingButtonsComponent } from '../evaluation-rating-buttons/evaluation-rating-buttons.component';

@Component({
  selector: 'rt-evaluation-scorecard-field',
  templateUrl: './evaluation-scorecard-field.component.html',
  styleUrls: ['./evaluation-scorecard-field.component.less'],
  imports: [BoxComponent, DividerComponent, EvaluationRatingButtonsComponent],
})
export class EvaluationScorecardFieldComponent {
  public readonly contents = input.required<FormArray<FormControl<RatingLevelType | null>>>();
  public readonly options = input<InterviewResultAnswerOption[]>([]);
  public readonly required = input<boolean>(false);
}
